<template>
  <div class="wrapper-slide-tns">
    <div class="card card-big-image" :class="{'card-big-image-without-bg' : cardBigImgWithoutBg}">
      <div class="infos" v-if="isMobileDisplay">
        <h3 class="title isMobile">
          {{article.getTitle()}}
        </h3>
      </div>
      <div class="infos" :class="{'infos-rwd': isLessThanDesktop}" v-else>
        <h3 class="title">
          <a :href="article.getLink()" v-focus v-if="elementToFocusOn">{{article.getTitle()}}</a>
          <a :href="article.getLink()" v-else>{{article.getTitle()}}</a>
        </h3>
        <p class="subcategory hidden-small" v-if="subCategoryLink">
          <a :href="subCategoryLink">{{article.getSubCategory()}}</a>
        </p>
        <a :href="article.getLink()"
          class="hidden-small btn-arrow btn-round-icon-only"
        >
          <span class="sr-only">Lire l'article</span>
        </a>
        <template v-if="categoryLink">
          <a @click.prevent="onCardCategoryClick(article)"
             :href="categoryLink"
             class="tag tag-white"
          >
            {{article.getCategory()}}
          </a>
        </template>
      </div>
      <div class="wrapper-img">
        <img
          v-if="article.getThumbnail()"
          :src="article.getThumbnail()"
          :alt="article.getTitle()" class="img">
      </div>
    </div>
  </div>
</template>
<script>
import { inject, computed } from 'vue';
import DecryptageUtils from '@/utils/decryptage';

const focus = {
  mounted: (el) => el.focus(),
};

export default {
  directives: {
    focus,
  },
  emit: ['onClickCardCategory', 'onClickCardSubCategory'],
  props: {
    article: {
      type: Object,
      default: () => ({}),
    },
    displaySubCategory: {
      type: Boolean,
      default: false,
    },
    cardBigImgWithoutBg: {
      type: Boolean,
      default: false,
    },
    elementToFocusOn: {
      type: Boolean,
      default: false,
    },
    isMobileDisplay: {
      type: Boolean,
      default: false,
    },
    cardIndex: {
      type: Number,
      default: 0,
    },
    trackLabel: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const isLessThanDesktop = inject('isLessThanDesktop');
    const baseUrl = inject('decodingBaseUrl');

    function onCardCategoryClick(category) {
      emit('onClickCardCategory', category);
    }

    function onCardSubcategoryClick(subCategory) {
      emit('onClickCardSubCategory', subCategory);
    }

    const categoryLink = computed(() => {
      const cat = props.article.getCategory();

      if (!baseUrl?.value || !cat) return '';

      const urlArr = [
        baseUrl.value,
        DecryptageUtils.encodeCategory(cat),
      ];

      return urlArr.join('/');
    });

    const subCategoryLink = computed(() => {
      const subCat = props.article.getSubCategory();

      if (!categoryLink?.value || !subCat) return '';

      const urlArr = [
        categoryLink.value,
        DecryptageUtils.encodeSubCategory(subCat),
      ];

      return urlArr.join('/');
    });

    return {
      onCardSubcategoryClick,
      onCardCategoryClick,
      isLessThanDesktop,
      categoryLink,
      subCategoryLink,
    };
  },
};
</script>
<style scoped lang="scss">
.infos-rwd {
   height: 100%;
  .title {
    position: absolute;
    bottom: 20px;
    width: 90%;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
